{
  "nameInput": {
    "placeholder": "Menene sunanka?"
  },
  "signIn": {
    "tagline": "Fara da niyya.",
    "signingIn": "Ana shiga…",
    "continueApple": "Ci gaba da Apple",
    "continueApple_aria": "Ci gaba da Apple",
    "continueGoogle": "Ci gaba da Google",
    "continueGoogle_aria": "Ci gaba da Google",
    "logo_alt": "Rhemn",
    "footer": "Ta hanyar shiga, ka yarda da sharuɗɗan sabis ɗinmu da <privacyLink>Manufar Sirri</privacyLink>.",
    "divider": "ko"
  },
  "email": {
    "identity": {
      "label": "Adireshin imel",
      "placeholder": "you@example.com",
      "change": "Canza",
      "change_aria": "Canza adireshin imel"
    },
    "password": {
      "label": "Kalmar sirri",
      "labelNew": "Zaɓi kalmar sirri",
      "placeholder": "Kalmar sirri",
      "placeholderNew": "Ƙirƙiri kalmar sirri",
      "show": "Nuna kalmar sirri",
      "hide": "Ɓoye kalmar sirri"
    },
    "actions": {
      "continue": "Ci gaba",
      "signIn": "Shiga",
      "createAccount": "Ƙirƙiri asusu",
      "forgot": "Ka manta kalmar sirri?",
      "backToSignIn": "Koma shiga",
      "iVerified": "Na tabbatar da imel dina",
      "resend": "Sake aika hanyar haɗi",
      "resendIn": "Sake aikawa cikin {{time}}",
      "signInInstead": "Shiga"
    },
    "busy": {
      "checking": "Ana bincike…",
      "signingIn": "Ana shiga…",
      "creating": "Ana ƙirƙirar asusunka…",
      "sending": "Ana aikawa…"
    },
    "switch": {
      "toCreate": "Sabo ne a Rhemn? <switchBtn>Ƙirƙiri asusu</switchBtn>",
      "toSignIn": "Kana da asusu? <switchBtn>Shiga</switchBtn>"
    },
    "strength": {
      "tooShort": "Aƙalla haruffa 12.",
      "level1": "Yayi kyau. Mai tsawo ya fi ƙarfi.",
      "level2": "Kalmar sirri mai ƙarfi.",
      "level3": "Kalmar sirri mai ƙarfi sosai."
    },
    "sent": {
      "title": "Duba akwatin saƙonninka",
      "body": "Mun aika hanyar haɗi don sake saitawa zuwa {{email}}. Za ta ƙare bayan awa ɗaya.",
      "resent": "An sake aikawa. Duba akwatin saƙonninka."
    },
    "verify": {
      "title": "Tabbatar da imel dinka",
      "body": "Mun aika hanyar haɗi zuwa {{email}}. Buɗe ta don kammala saita asusunka — za mu ci gaba kai tsaye daga nan.",
      "waiting": "Muna jiran ka buɗe hanyar haɗin…",
      "resent": "An sake aikawa. Duba akwatin saƙonninka."
    },
    "errors": {
      "invalidEmail": "Wannan bai yi kama da adireshin imel ba.",
      "missingPassword": "Shigar da kalmar sirrinka.",
      "invalidCredential": "Imel ko kalmar sirri ba daidai ba ne.",
      "emailInUse": "Wannan imel yana da asusu riga. <signInBtn>Ka shiga maimakon haka.</signInBtn>",
      "weakPassword": "Yi amfani da aƙalla haruffa 12.",
      "passwordTooShort": "Yi amfani da aƙalla haruffa 12.",
      "passwordCommon": "Wannan kalmar sirri tana da sauƙin tsammani. Gwada wani abu da ba a saba tsammani ba.",
      "emailNotVerified": "Tabbatar da imel dinka kafin ka ci gaba.",
      "providerGoogle": "An riga an saita wannan imel da Google. Ci gaba da Google a ƙasa.",
      "providerApple": "An riga an saita wannan imel da Apple. Ci gaba da Apple a ƙasa.",
      "userDisabled": "An kashe wannan asusu.",
      "requiresRecentLogin": "Sake shiga don yin wannan canjin.",
      "sessionExpired": "Zaman ka ya ƙare. Sake shiga.",
      "expiredActionCode": "Wannan hanyar haɗin ta ƙare. Nemi sabuwa.",
      "invalidActionCode": "Wannan hanyar haɗin ba ta aiki kuma. Nemi sabuwa.",
      "tooManyRequests": "Yunƙuri da yawa. Jira ƴan mintuna, ko sake saita kalmar sirrinka.",
      "network": "Babu haɗi. Duba hanyar sadarwarka ka sake gwadawa.",
      "operationNotAllowed": "Shiga ta imel ba ya samuwa a yanzu.",
      "generic": "Wani abu ya faskara. Da fatan za a sake gwadawa."
    },
    "a11y": {
      "stepEmail": "Mataki 1 daga 2. Shigar da adireshin imel dinka.",
      "stepPasswordSignIn": "Mataki 2 daga 2. Shigar da kalmar sirrinka don shiga.",
      "stepPasswordCreate": "Mataki 2 daga 2. Zaɓi kalmar sirri don sabon asusunka.",
      "stepSent": "An aika hanyar haɗin sake saitawa. Duba akwatin saƙonninka.",
      "stepVerify": "An ƙirƙiri asusu. An aika hanyar haɗin tabbatarwa.",
      "resendReady": "Yanzu za ka iya sake aika hanyar haɗin."
    }
  }
}
